import axiosInstance from "../axiosInstance";

import type { CommunityPopularResponse } from "../types/community.types";
import type { CommunityPostResponse, CommunityPostListResponse } from "../types/report.types";

const BASE = "/community/api/v1";

export const communityService = {
  getPost: (postId: string | number) => axiosInstance.get<CommunityPostResponse>(`${BASE}/posts/${postId}`),

  getUserPosts: (userId: string, limit = 5) => axiosInstance.get<CommunityPostListResponse>(`${BASE}/users/${encodeURIComponent(userId)}/posts`, { params: { page: 1, limit } }),

  /** 홈 화면 인기게시글 목록 조회 */
  getPopularPosts: () => axiosInstance.get<CommunityPopularResponse>(`${BASE}/home/popular`),
};
